import { Button, styled } from '@mui/material';

export const Section = styled('div')(({ theme }) => ({
  padding: '1rem',
  backgroundColor: theme.colorTokens.surface,
  border: `1px solid ${theme.colorTokens.outline}`,
  marginBottom: '1rem',
  height: '100%',
  width: '100%',
  boxSizing: 'border-box',

  '& .section__header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: theme.colorTokens.onSurfaceTextHeadline,
  },

  '& .section__title': {
    color: theme.colorTokens.onSurfaceTextHeadline,
    fontSize: '16px',
    fontWeight: 600,
    marginTop: 0,

    '&--no-margin': {
      margin: 0,
    },

    '&--h40': {
      minHeight: '40px',
    },
  },

  '& .section__body': {
    color: theme.colorTokens.onSurfaceTextLabel,
  },
}));

export const Heading = styled('h3')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: '0 0 0.5rem 0',
  color: theme.colorTokens.onSurfaceTextHeadline,
  fontWeight: 600,
}));

export const EditButton = styled(Button)({
  lineHeight: 1.2,
  fontSize: '12px',
  textTransform: 'unset',
  borderRadius: '2rem',
});

export const Hr = styled('div')(({ theme }) => ({
  margin: '1rem 0',
  height: '1px',
  backgroundColor: theme.colorTokens.outlineVariant2,
}));
